// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__AR-Cr","search":"Settings_search__1e_NE","filter":"Settings_filter__3PkFA"};